import { ERiskLevel } from '../subcomponents/score-dashboard/subcomponents/score-result/types';

const SCORE_LOW_THRESHOLD = 700;
const SCORE_MEDIUM_THRESHOLD = 400;

const PF_RISK_CODE_MAP: Record<string, ERiskLevel> = {
  '0003': ERiskLevel.LOW,
  '0002': ERiskLevel.HIGH,
};

const PJ_RISK_CODE_MAP: Record<string, ERiskLevel> = {
  '0005': ERiskLevel.LOW,
  '0001': ERiskLevel.MEDIUM,
  '0002': ERiskLevel.MEDIUM,
  '0004': ERiskLevel.MEDIUM,
  '0003': ERiskLevel.HIGH,
};

export function deriveRiskLevelFromScore(score: number): ERiskLevel {
  if (score >= SCORE_LOW_THRESHOLD) return ERiskLevel.LOW;
  if (score >= SCORE_MEDIUM_THRESHOLD) return ERiskLevel.MEDIUM;
  return ERiskLevel.HIGH;
}

export function deriveBusinessRiskLevel(isCompany: boolean, riskAssessmentCode?: string): ERiskLevel | null {
  const code = (riskAssessmentCode ?? '').trim();
  const map = isCompany ? PJ_RISK_CODE_MAP : PF_RISK_CODE_MAP;
  return map[code] ?? null;
}
